import CalculatorIcon from '../../../../../icons/calculator.svg?react';
import DollarTagIcon from '../../../../../icons/dollar-tag.svg?react';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg?react';
import madeEasy from '../../../../../icons/madeEasy.svg?react';
import optionsTailored from '../../../../../icons/optionsTailored.svg?react'
import solutionsRight from '../../../../../icons/SolutionsRight.svg?react';

export default function PurchasingProcessData() {
    return {
        title: "Our Purchasing Process",
        subtitle: "We offer a wide range of the top rated, most competitively priced insurance companies to provide the highest value coverage. Our team of licensed experts will help you secure the right company and coverage in 3 easy steps.",
        steps: [
            {
                title: "Determine Coverage Amount and Review Quotes",
                icon: CalculatorIcon,
                paragraphs: [
                    "Based on your needs and budget, you can select from $2,000 to $50,000 of benefits. There are only a handful of questions to get your initial quote from multiple companies. We’ll review your top options to help determine the best choice.",
                ]
            },
            {
                title: "Apply and Receive Carrier Approval",
                icon: DollarTagIcon,
                paragraphs: [
                    "The application and approval process is simple, and can typically be completed right over the phone in less than 10 minutes. You will also be notified via email when your application is approved.",
                ]
            },
            {
                title: "Review Policy and Activate Coverage",
                icon: HandSelectClickIcon,
                paragraphs: [
                    "Once approved by the carrier, you will receive your policy electronically for review. To activate your coverage, you simply need to sign and make your first payment.",
                ]
            },
        ],
        stepsfooter:[
            {
                title: "Choice and affordability to meet your budget",
                icon: madeEasy,
                paragraphs: [
                    "As a broker, we are not beholden to only 1 insurance company. We represent a broad range of A rated companies that offer the most competitive prices. That means you get the best options to find the right coverage to meet your needs and budget.",
                ]
            },
            {
                title: "Expert service and easy application process",
                icon: optionsTailored,
                paragraphs: [
                    "We make the application process easy. There’s no medical exam and only a handful of questions to qualify. Our team of licensed experts are knowledgeable, friendly and will help you find the right policy, customized just for you.",
                ]
            },
            {
                title: "Guaranteed approval with lifetime security",
                icon: solutionsRight,
                paragraphs: [
                    "No matter if you have any health concerns or prior medical conditions, your policy acceptance is guaranteed. Once approved, your prices are locked in for your lifetime and can never be increased, even if your health changes. As long as you pay your premiums on time, your policy can never be cancelled.",
                ]
            },
        ]
    }
}